import React from 'react'
import { Grid, Typography } from '@mui/material'
import { useGetWalletsQuery } from '../../../../api/asset-holders/financeApi'
import type { LedgerAccountDetails } from '../../../../api/schema-dtos/AssetHolderFinancePayloadDtos'
import type { AssetHolderSettlementProps } from '../../../../api/schema-dtos/SettlementDomainDtos'
import { RtkQueryHelper } from '../../../../api/shared/RtkQueryHelper'
import ErrorComponent from '../../../shared/components/ui-widgets/ErrorComponent'
import LoadingComponent from '../../../shared/components/ui-widgets/LoadingComponent'

const PortfolioSettlementDetails: React.FC<AssetHolderSettlementProps> = ({ settlementDto }: AssetHolderSettlementProps) => {
  const getWalletsApiResult = useGetWalletsQuery(settlementDto.assetHolderId)

  return (
    <>
      <Grid container spacing={3}>
        <Grid item md={2}>
          <Typography variant={'h4'}>Total Settlement</Typography>
        </Grid>
        <Grid item md={10}>
          <Typography variant={'h4'} >{settlementDto.currencyCode} {settlementDto.settlementTotalAmountFormatted}</Typography>
        </Grid>

        {/* <Grid item md={12} sx={{ my: 2 }}/> */}

        <Grid item md={2}>
          <Typography variant={'h4'}>Status</Typography>
        </Grid>
        <Grid item md={10}>
          <Typography variant={'body1'}>{settlementDto.statusMessage}</Typography>
        </Grid>

        {/* <Grid item md={2}> */}
        {/*  <Typography variant={'h4'}>KYC Status</Typography> */}
        {/* </Grid> */}
        {/* <Grid item md={10}> */}
        {/*  <Alert severity="warning">INCOMPLETE - Please complete and verify your details on the member profile tab.</Alert> */}
        {/* </Grid> */}

      </Grid>

      <Grid container sx={{ mt: 3 }}>
        <Grid item md={2}>
          <Typography variant={'h4'}>Wallet Balances</Typography>
        </Grid>
        <Grid item md={10}>
          {getWalletsApiResult.isLoading && <LoadingComponent/>}
          {getWalletsApiResult.isError &&
            <ErrorComponent message={RtkQueryHelper.mapResponseError(getWalletsApiResult.error)}/>}

          { getWalletsApiResult.isSuccess && getWalletsApiResult.data.map((wallet: LedgerAccountDetails, index: number) => (
            <React.Fragment key={wallet.currencyCode}>
              <Typography variant={'body1'} >{wallet.currencyDisplayCode} {wallet.availableBalanceFormatted}</Typography>
            </React.Fragment>
          )) }
        </Grid>
      </Grid>
    </>
  )
}

export default PortfolioSettlementDetails
